(function () {
  'use strict';
  var d = document;
  d.documentElement.classList.remove('no-js');

  /* Mobile menu, including theme-editor section replacement. */
  function initHeader(){
    var header=d.querySelector('[data-header]');
    if(!header||header.dataset.menuReady)return;
    var toggle=header.querySelector('[data-menu-toggle]');if(!toggle)return;
    header.dataset.menuReady='true';
    function closeMenu(){header.classList.remove('is-open');toggle.setAttribute('aria-expanded','false');}
    toggle.addEventListener('click',function(){var open=header.classList.toggle('is-open');toggle.setAttribute('aria-expanded',String(open));});
    header.addEventListener('click',function(e){if(e.target.closest('.main-nav a'))closeMenu();});
    function outside(e){if(!header.isConnected){d.removeEventListener('click',outside);return;}if(!header.contains(e.target))closeMenu();}
    function escape(e){if(!header.isConnected){d.removeEventListener('keydown',escape);return;}if(e.key==='Escape'&&header.classList.contains('is-open')){closeMenu();toggle.focus();}}
    d.addEventListener('click',outside);d.addEventListener('keydown',escape);
    var mq=window.matchMedia('(min-width: 990px)');
    function resize(){if(!header.isConnected){mq.removeEventListener('change',resize);return;}closeMenu();}
    mq.addEventListener('change',resize);
  }
  initHeader();d.addEventListener('shopify:section:load',initHeader);

  function initProducts(root){
  /* Product variant picker */
  root.querySelectorAll('[data-product-section]').forEach(function (section) {
    if(section.dataset.variantsReady)return;section.dataset.variantsReady='true';
    var dataEl = section.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var form = section.querySelector('form[action*="/cart/add"]') || section.querySelector('#product-form');
    var idInput = section.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-price]');
    var button = section.querySelector('[data-add]');
    var labelAdd = button ? button.getAttribute('data-label-add') : '';
    var labelSold = button ? button.getAttribute('data-label-sold') : '';
    var fieldsets = section.querySelectorAll('[data-option-index]');

    function selectedOptions() {
      var out = [];
      fieldsets.forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        out.push(checked ? checked.value : null);
      });
      return out;
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function update() {
      var v = findVariant(selectedOptions());
      if (!v) {
        if(idInput){idInput.value='';idInput.disabled=true;}
        if (button) { button.disabled = true; button.textContent = labelSold; }
        return;
      }
      if (idInput){idInput.value=v.id;idInput.disabled=false;}
      if (priceEl) {
        priceEl.textContent = v.price;
        if (v.compare) {
          var s = d.createElement('s');
          s.textContent = v.compare;
          priceEl.appendChild(s);
        }
      }
      if (button) {
        button.disabled = !v.available;
        button.textContent = v.available ? labelAdd : labelSold;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      if(v.image)section.dispatchEvent(new CustomEvent('rllp:gallery-select',{detail:{imageId:'img-'+v.image}}));
    }

    if(form)form.addEventListener('submit',function(e){var v=findVariant(selectedOptions());if(!v || !v.available)e.preventDefault();});
    if (form) form.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') update();
    });
  });
  }
  initProducts(d);
  d.addEventListener('shopify:section:load',function(){initProducts(d);});
})();

document.addEventListener('change', function(e){
 if(e.target.matches('[data-sort]')){var u=new URL(location.href);u.searchParams.set('sort_by',e.target.value);u.searchParams.delete('page');location.href=u.toString();}
 if(e.target.matches('[data-auto-submit]') && e.target.form)e.target.form.submit();
});
document.addEventListener('click',function(e){var b=e.target.closest('[data-filter-toggle]');if(!b)return;var panel=document.getElementById(b.getAttribute('aria-controls'));if(panel)b.setAttribute('aria-expanded',panel.classList.toggle('is-open')?'true':'false');});

/* Business slideshow: supports theme-editor refresh and block selection. */
(function(){
 var instances=new WeakMap();
 function init(root){
  root.querySelectorAll('[data-slideshow]').forEach(function(el){
   if(instances.has(el))return;
   var slides=Array.from(el.querySelectorAll('[data-slide]')),dots=Array.from(el.querySelectorAll('[data-slide-to]'));
   if(slides.length<2)return;
   var index=0,hover=false,focused=false,editor=Boolean(window.Shopify && window.Shopify.designMode),paused=editor || el.dataset.autoplay!=='true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
   var pause=el.querySelector('[data-slide-pause]');
   function syncPause(){if(pause){pause.setAttribute('aria-pressed',String(paused));pause.setAttribute('aria-label',paused?'Play automatic slideshow':'Pause automatic slideshow');pause.textContent=paused?'▶':'Ⅱ';}}
   function show(i){index=(i+slides.length)%slides.length;slides.forEach(function(s,j){s.hidden=j!==index;s.toggleAttribute('inert',j!==index);s.classList.toggle('is-active',j===index)});dots.forEach(function(b,j){b.setAttribute('aria-pressed',String(j===index))});}
   var prev=el.querySelector('[data-slide-prev]'),next=el.querySelector('[data-slide-next]');
   if(prev)prev.addEventListener('click',function(){show(index-1)});
   if(next)next.addEventListener('click',function(){show(index+1)});
   dots.forEach(function(b){b.addEventListener('click',function(){show(Number(b.dataset.slideTo))})});
   if(pause)pause.addEventListener('click',function(){paused=!paused;syncPause()});
   el.addEventListener('mouseenter',function(){hover=true});el.addEventListener('mouseleave',function(){hover=false});
   el.addEventListener('focusin',function(){focused=true});el.addEventListener('focusout',function(e){focused=el.contains(e.relatedTarget)});
   var touch=null,suppressImageClickUntil=0;
   el.addEventListener('touchstart',function(e){
    suppressImageClickUntil=0;
    var control=e.target.closest('a,button,input,select,textarea');
    if(e.touches.length===1&&(!control||control.classList.contains('hero-image-link')))touch={x:e.touches[0].clientX,y:e.touches[0].clientY};else touch=null;
   },{passive:true});
   el.addEventListener('touchend',function(e){
    if(!touch||!e.changedTouches.length)return;
    var dx=e.changedTouches[0].clientX-touch.x,dy=e.changedTouches[0].clientY-touch.y;touch=null;
    if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5){suppressImageClickUntil=Date.now()+500;show(index+(dx<0?1:-1));}
   },{passive:true});
   el.addEventListener('touchcancel',function(){touch=null;},{passive:true});
   el.addEventListener('click',function(e){if(e.target.closest('.hero-image-link')&&Date.now()<suppressImageClickUntil)e.preventDefault();},true);
   var timer=window.setInterval(function(){if(!paused&&!hover&&!focused&&!document.hidden)show(index+1)},Number(el.dataset.interval)||6000);
   instances.set(el,{show:show,stop:function(){window.clearInterval(timer)},select:function(id){var i=slides.findIndex(function(s){return s.dataset.blockId===id});if(i>=0){paused=true;syncPause();show(i)}}});syncPause();
  });
 }
 init(document);
 document.addEventListener('shopify:section:load',function(){init(document)});
 document.addEventListener('shopify:section:unload',function(e){e.target.querySelectorAll('[data-slideshow]').forEach(function(el){var item=instances.get(el);if(item)item.stop();instances.delete(el)})});
 document.addEventListener('shopify:block:select',function(e){var el=e.target.closest('[data-slideshow]');if(el&&instances.has(el))instances.get(el).select(e.detail.blockId)});
})();

/* Collapse contact shortcuts on phones; keep links visible without JavaScript. */
(function(){
 var instances=new WeakMap();
 function init(root){
  root.querySelectorAll('[data-contact-dock]').forEach(function(dock){
   if(instances.has(dock))return;
   var toggle=dock.querySelector('[data-contact-toggle]'),links=dock.querySelector('[data-contact-links]');
   if(!toggle||!links)return;
   var mobile=window.matchMedia('(max-width: 749px)');
   function setOpen(open){
    var expanded=!mobile.matches||open;
    links.hidden=!expanded;
    toggle.setAttribute('aria-expanded',String(expanded));
    dock.classList.toggle('is-open',mobile.matches&&open);
   }
   function resize(){setOpen(false);}
   function outside(e){if(mobile.matches&&!dock.contains(e.target))setOpen(false);}
   function escape(e){if(mobile.matches&&e.key==='Escape'&&!links.hidden){setOpen(false);toggle.focus();}}
   function toggleLinks(){setOpen(links.hidden);}
   function followLink(e){if(e.target.closest('a[href]'))setOpen(false);}
   toggle.addEventListener('click',toggleLinks);
   links.addEventListener('click',followLink);
   document.addEventListener('click',outside);
   document.addEventListener('keydown',escape);
   mobile.addEventListener('change',resize);
   setOpen(false);dock.dataset.contactReady='true';
   instances.set(dock,function(){
    toggle.removeEventListener('click',toggleLinks);links.removeEventListener('click',followLink);
    document.removeEventListener('click',outside);document.removeEventListener('keydown',escape);
    mobile.removeEventListener('change',resize);
   });
  });
 }
 init(document);
 document.addEventListener('shopify:section:load',function(){init(document);});
 document.addEventListener('shopify:section:unload',function(e){e.target.querySelectorAll('[data-contact-dock]').forEach(function(dock){var clean=instances.get(dock);if(clean)clean();instances.delete(dock);});});
})();

/* Contextual WhatsApp inquiry: never sends a message without the customer. */
(function(){
 function read(selector,root){var el=(root||document).querySelector(selector);if(!el)return null;try{return JSON.parse(el.textContent)}catch(e){return null}}
 function number(){var n=String(read('[data-whatsapp-config]')||'').replace(/\D/g,'');return /^\d{7,15}$/.test(n)?n:''}
 function productMessage(section){
  var id=section.querySelector('[data-variant-id]'),qtyEl=section.querySelector('[name="quantity"]'),qty=qtyEl?Number(qtyEl.value):1,error=section.querySelector('[data-whatsapp-inquiry-error]');
  var data=read('[data-whatsapp-product]',section),variants=read('[data-variants]',section)||[];
  var v=id&&!id.disabled&&variants.find(function(x){return String(x.id)===String(id.value)});
  if(!data||!v||!Number.isInteger(qty)||qty<1){if(error)error.hidden=false;return null}if(error)error.hidden=true;
  var url=new URL(data.url,location.origin);url.searchParams.set('variant',v.id);
  var lines=['Hello! I would like to ask about this product.','Product: '+data.title];
  section.querySelectorAll('[data-option-index]').forEach(function(fs){var checked=fs.querySelector('input:checked'),legend=fs.querySelector('legend');if(checked)lines.push((legend?legend.textContent.trim():'Option')+': '+checked.value)});
  lines.push('Quantity: '+qty,'Unit price: '+v.price+' ('+data.currency+')','Product link: '+url.href,'Please confirm availability, delivery and your best price.');return lines.join('\n');
 }
 function cartMessage(){
  var data=read('[data-whatsapp-cart-data]'),section=document.querySelector('[data-cart-section]');if(!data||!section)return null;
  var rows=Array.from(section.querySelectorAll('[data-cart-line]')),error=section.querySelector('[data-cart-inquiry-error]');
  var changed=rows.some(function(row,i){var input=row.querySelector('[data-cart-quantity]');return !data.items[i]||Number(input.value)!==data.items[i].quantity});
  if(changed){if(error)error.hidden=false;return null}if(error)error.hidden=true;
  var lines=['Hello! Please quote the following cart:'];data.items.forEach(function(item,i){lines.push((i+1)+'. '+item.title);if(item.variant!=='Default Title')lines.push('Options: '+item.variant);lines.push('Quantity: '+item.quantity,'Unit price: '+item.price,'Link: '+new URL(item.url,location.origin).href)});
  lines.push('Cart subtotal: '+data.total,'Please confirm shipping and your best total price.');return lines.join('\n');
 }
 function init(){var n=number();document.querySelectorAll('[data-whatsapp-inquiry],[data-whatsapp-cart]').forEach(function(b){b.hidden=!n});}
 document.addEventListener('click',function(e){
  var button=e.target.closest('[data-whatsapp-inquiry],[data-whatsapp-cart],[data-whatsapp-context]');if(!button)return;
  if(button.getAttribute('aria-disabled')==='true')return;e.preventDefault();var n=number();if(!n)return;
  var section=document.querySelector('[data-product-section]'),cart=document.querySelector('[data-cart-section]'),message;
  if(button.matches('[data-whatsapp-inquiry]'))message=productMessage(button.closest('[data-product-section]'));
  else if(button.matches('[data-whatsapp-cart]'))message=cartMessage();
  else if(section)message=productMessage(section);
  else if(cart&&read('[data-whatsapp-cart-data]')&&read('[data-whatsapp-cart-data]').items.length)message=cartMessage();
  else message='Hello! I would like some help with this page: '+location.origin+location.pathname;
  if(message)window.open('https://wa.me/'+n+'?text='+encodeURIComponent(message),'_blank','noopener,noreferrer');
 });init();document.addEventListener('shopify:section:load',init);
})();

/* Scroll-snap gallery: dots and variants move only the image track. */
(function(){
 function init(root){root.querySelectorAll('[data-product-section]').forEach(function(section){
  var gallery=section.querySelector('[data-product-gallery]');if(!gallery||gallery.dataset.ready)return;gallery.dataset.ready='true';
  var figures=Array.from(gallery.querySelectorAll('figure')),dots=Array.from(section.querySelectorAll('[data-gallery-image]'));
  function mobile(){return window.matchMedia('(max-width: 899px)').matches;}
  var selectedId=null,thumbnails=Array.from(section.querySelectorAll('[data-gallery-thumbnail]'));
  function activate(figure){figures.forEach(function(f){if(f!==figure){f.querySelectorAll('video').forEach(function(v){v.pause();});var player=f.querySelector('[data-external-player]');if(player)player.replaceChildren();}});var template=figure.querySelector('[data-external-video]'),host=figure.querySelector('[data-external-player]');if(template&&host&&!host.firstChild)host.appendChild(template.content.cloneNode(true));}
  function select(id,instant){var figure=figures.find(function(f){return f.id===id});if(!figure)return;selectedId=id;activate(figure);thumbnails.forEach(function(b){b.setAttribute('aria-pressed',String(b.dataset.galleryThumbnail===id));});figures.forEach(function(f){f.classList.toggle('is-variant-main',f===figure);});gallery.classList.add('has-variant-main');var image=figure.querySelector('img');if(image)image.loading='eager';if(!mobile())return;var dx=figure.getBoundingClientRect().left-gallery.getBoundingClientRect().left;gallery.scrollBy({left:dx,behavior:instant||window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
  function sync(){if(!mobile())return;var left=gallery.getBoundingClientRect().left,index=0,min=Infinity;figures.forEach(function(f,i){var distance=Math.abs(f.getBoundingClientRect().left-left);if(distance<min){min=distance;index=i;}});dots.forEach(function(b,i){b.setAttribute('aria-pressed',String(i===index));});if(figures[index])activate(figures[index]);}
  dots.forEach(function(b){b.addEventListener('click',function(){select(b.dataset.galleryImage);});});
  thumbnails.forEach(function(b){b.addEventListener('click',function(){select(b.dataset.galleryThumbnail);});});
  gallery.addEventListener('scroll',sync,{passive:true});
  gallery.addEventListener('keydown',function(e){if(!mobile()||!['ArrowLeft','ArrowRight'].includes(e.key))return;e.preventDefault();var current=dots.findIndex(function(b){return b.getAttribute('aria-pressed')==='true'});var rtl=getComputedStyle(gallery).direction==='rtl';var step=(e.key==='ArrowRight'?1:-1)*(rtl?-1:1);var next=Math.max(0,Math.min(figures.length-1,current+step));if(figures[next])select(figures[next].id);});
  section.addEventListener('rllp:gallery-select',function(e){select(e.detail.imageId);});
  window.matchMedia('(max-width: 899px)').addEventListener('change',function(){if(selectedId)select(selectedId,true);});
  select(gallery.dataset.initialImage?'img-'+gallery.dataset.initialImage:(figures[0]&&figures[0].id),true);sync();
 });}
 init(document);document.addEventListener('shopify:section:load',function(){init(document);});
})();

/* Accessible optional newsletter dialog, with a remembered dismissal. */
(function(){
 function init(){document.querySelectorAll('[data-newsletter-popup]').forEach(function(dialog){
  if(dialog.dataset.ready)return;dialog.dataset.ready='true';if(!dialog.showModal)return;
  var key='ruilubags-newsletter-dismissed',previous=null,timer;
  function seen(){try{return Number(localStorage.getItem(key)||0)>Date.now()}catch(e){return false}}
  function remember(){try{localStorage.setItem(key,String(Date.now()+Number(dialog.dataset.days||7)*86400000))}catch(e){}}
  function open(){if(!dialog.isConnected||dialog.open)return;previous=document.activeElement;dialog.showModal();}
  function close(){remember();dialog.close();}
  dialog.querySelectorAll('[data-popup-close]').forEach(function(b){b.addEventListener('click',close)});
  dialog.addEventListener('cancel',remember);dialog.addEventListener('close',function(){if(previous&&previous.isConnected)previous.focus()});
  dialog.addEventListener('click',function(e){if(e.target!==dialog)return;var r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close()});
  var feedback=dialog.querySelector('[data-popup-success],[data-popup-error]');
  if(feedback){if(dialog.querySelector('[data-popup-success]'))remember();open()}
  else if(!(window.Shopify&&Shopify.designMode)&&!seen())timer=setTimeout(open,Number(dialog.dataset.delay)||15000);
  dialog.addEventListener('shopify:section:unload',function(){clearTimeout(timer)});
 });}
 init();document.addEventListener('shopify:section:load',init);
})();

/* Move videos embedded in merchant descriptions above the full-width description. */
(function(){
 function init(){document.querySelectorAll('[data-product-section]').forEach(function(section){
  var description=section.querySelector('[data-product-description]'),videos=section.querySelector('[data-product-detail-videos]');if(!description||!videos)return;
  description.querySelectorAll('video,iframe').forEach(function(player){
   if(player.tagName==='IFRAME'&&!/youtube|youtu\.be|vimeo/i.test(player.src))return;
   var parent=player.parentElement,wrapper=document.createElement('div');wrapper.className='product-detail-video';
   if(player.tagName==='VIDEO'){player.controls=true;player.autoplay=false;player.removeAttribute('autoplay');player.setAttribute('playsinline','');}
   wrapper.appendChild(player);videos.appendChild(wrapper);
   if(parent!==description&&!parent.textContent.trim()&&!parent.querySelector('img,video,iframe'))parent.remove();
  });
 });}
 init();document.addEventListener('shopify:section:load',init);
})();
